import { preserveItems, restorePreserved } from '../util/local-storage-preserve.service';
import { APP_UPDATE_PENDING_KEY } from '../../constants/app-update.constants';
import {
  comEsquemaBearer,
  emRetornoDeLogin,
  encerrarSessaoNestaAba,
  isKeycloakEnabled,
  isKeycloakSession,
  limparSessaoKeycloak,
  tokenValido,
} from './keycloak/keycloak.util';

export class AuthInterceptor {
  constructor($rootScope, localStorageService, $location, $window) {
    "ngInject";

    this.$rootScope = $rootScope;
    this.localStorageService = localStorageService;
    this.$location = $location;
    this.$window = $window;

    this.request = (config) => {
      this.$rootScope.$emit("loading:start");

      // limpa o alerta de problema na conexão, se existe.
      if (this.$rootScope.alertConnectionProblem) {
        this.$rootScope.alertConnectionProblem = null;
      }

      // se o token existe no local storage, add authorization token to headers.
      config.headers = config.headers || {};
      if (
        this.localStorageService.get("token") &&
        config.url.indexOf("maps.googleapis.com") === -1
      ) {
        // config.headers.Authorization = 'Bearer ' + localStorageService.get('token');
        config.headers.Authorization = this.localStorageService
          .get("token")
          .trim();

        // Sessao do Keycloak: o token e um JWT (precisa do esquema Bearer) e e renovado aqui
        // antes de expirar. tokenValido() divide uma unica renovacao entre chamadas paralelas.
        if (isKeycloakSession()) {
          return tokenValido()
            .then((token) => {
              config.headers.Authorization = comEsquemaBearer(token);
            })
            .catch(() => {
              // segue com o token atual; se estiver morto, o 401 resolve
              config.headers.Authorization = comEsquemaBearer(
                config.headers.Authorization
              );
            })
            .then(() => this.addWafToken(config));
        }
      } else {
        delete config.headers.Authorization;
      }

      // Anexa o token do AWS WAF nos hosts protegidos (cross-domain via header).
      return this.addWafToken(config);
    };

    // Adiciona o header x-aws-waf-token quando o host está protegido pelo WAF.
    // Lê a config exposta em window.__mandaeWaf (definida pelo aws-waf.util do Angular).
    this.addWafToken = (config) => {
      const waf = this.$window.__mandaeWaf;
      const integration = this.$window.AwsWafIntegration;

      if (
        !waf ||
        !waf.enabled ||
        !integration ||
        !config.url ||
        !(waf.protectedHosts || []).some(
          (host) => config.url.indexOf(host) > -1
        )
      ) {
        return config;
      }

      return integration
        .getToken()
        .then((token) => {
          if (token) {
            config.headers["x-aws-waf-token"] = token;
          }
          return config;
        })
        .catch(() => config);
    };

    this.requestError = (rejection) => {
      // para o loading
      this.$rootScope.$emit("loading:stop");

      return rejection;
    };

    this.response = (response) => {
      // para o loading
      this.$rootScope.$emit("loading:stop");

      return response;
    };

    this.responseError = async (response) => {
      this.$rootScope.$emit("loading:stop");
      const statusCode = response.status;
      const url = response.config.url;

      const isUrlPlataformas = url.indexOf("/plataformas/") > -1;
      // se o token for invalido
      if (
        statusCode === 401 &&
        !url.endsWith("/v1/collaborator/authorize") &&
        !isUrlPlataformas
      ) {
        // With Keycloak on, /login is the sign-in itself. A 401 there comes from a call that left before
        // the new token was stored; wiping the storage now would throw away the session loginKeycloak is
        // finishing and send the user straight back to Keycloak.
        if (
          isKeycloakEnabled() &&
          (emRetornoDeLogin(this.$window.location.search) ||
            this.$location.path().endsWith("/login"))
        ) {
          throw response;
        }

        if (isKeycloakSession()) {
          // Only this tab's session ends: ls.token and ls.user are shared by every tab, and another
          // tab may still renew the token with its own refresh token.
          encerrarSessaoNestaAba();
        } else {
          let items = preserveItems()
          // limpa local storage, inclusive tokens
          this.localStorageService.clearAll();
          restorePreserved(items);
          // o refresh/id token do Keycloak vivem no sessionStorage e morrem junto
          limparSessaoKeycloak();
        }

        // Verificar se existe atualização pendente do Service Worker
        const hasUpdatePending = localStorage.getItem(APP_UPDATE_PENDING_KEY) === 'true';

        if (hasUpdatePending) {

          // Limpar flag antes de recarregar (evita loop infinito)
          localStorage.removeItem(APP_UPDATE_PENDING_KEY);

          // Forçar reload para carregar nova versão
          console.log('[AuthInterceptor] Atualização pendente detectada. Recarregando aplicação...');
          this.$window.location.reload();

          return; // Não continua execução
        }

        // outside the sign-in page itself, send the user to the login
        if (!this.$location.path().endsWith("/login")) {
          this.$window.location.href = "/login";
        }

        throw response;
      } else if (statusCode === 0) {
        this.$rootScope.alertConnectionProblem =
          "Falha na comunicação com o servidor. Verifique sua conexão com a Internet.";
        this.$log.info("Falha na conexão com o servidor.");

        throw response;
      }

      throw response;
    };
  }
}
